import React from "react";
import Lottie from "react-lottie";
import styled from "styled-components";
import loaderAnimation from "../../../assets/lottie/blast.json";

export default function LottieCracker() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    path: "https://assets2.lottiefiles.com/packages/lf20_u4yrau.json",
    // animationData: loaderAnimation,
    rendererSettings: {},
  };
  return (
    <Container>
      <Lottie options={defaultOptions} height={1000} />
    </Container>
  );
}
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
`;
